import { render, staticRenderFns } from "./netFail.vue?vue&type=template&id=5464a2c4&scoped=true"
import script from "./netFail.vue?vue&type=script&lang=ts"
export * from "./netFail.vue?vue&type=script&lang=ts"
import style0 from "./netFail.vue?vue&type=style&index=0&id=5464a2c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5464a2c4",
  null
  
)

export default component.exports